// extracted by mini-css-extract-plugin
module.exports = {"icon":"PinButton_icon__RBqvi"};